import { render, staticRenderFns } from "./Unknown.vue?vue&type=template&id=79f9478a&"
import script from "./Unknown.vue?vue&type=script&lang=js&"
export * from "./Unknown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports